module.exports = __webpack_public_path__ + "images/rich_heading/sports/fishing/icon_06d55ff5ebe41c1d505a93368fc5ca09.png";